<template>
	<div class="bright-main">
		<circle-img v-if="imgShow"></circle-img>
		<circle-imgEn v-else></circle-imgEn>
		<!-- <smallSearch></smallSearch> -->
			<div class="content">
				<span class="title">{{$t('chapter1[0]')}}</span>
				<div class="chapter1">
					<div class="mix-content">
						<img src="static/image/bright-img/a.jpg" alt="图片" class="inner-img">
						<span class="min-title">{{$t('chapter2[0].min-title')}}</span>
						<span class="min-inner">{{$t('chapter2[0].min-inner')}}</span>
					</div>
					<div class="mix-content">
						<img src="static/image/bright-img/b.jpg" alt="图片" class="inner-img">
						<span class="min-title">{{$t('chapter2[1].min-title')}}</span>
						<span class="min-inner">{{$t('chapter2[1].min-inner')}}</span>
					</div>
					<div class="mix-content">
						<img src="static/image/bright-img/c.jpg" alt="图片" class="inner-img">
						<span class="min-title">{{$t('chapter2[2].min-title')}}</span>
						<span class="min-inner">{{$t('chapter2[2].min-inner')}}</span>
					</div>
				</div>
			</div>
			<div id="arch2" class="inner-img">
				<img class="car-img" src="static/image/bright-img/yellow-picture.jpg"/>
				<!-- <large-search class="search-box"></large-search> -->
			</div>
			<div class="product-link">
				<span class="all-product">{{$t('serivelink[0]')}}</span>
				<div @mouseover="changeImg(index)" 
						 @mouseout="returnImg(index)"
						 @click = "jump(index)"
							class="click-link" 
							v-for="(item,index) in productText">
					<img :class="index" :src="'static/image/bright-img/' + index + '.jpg'"/>
					<img class="click-img" :src="'static/image/bright-img/' + index + '.jpg'"/>
					<span>{{item}}</span>
					<div class="click-svg">
						<svg viewBox="0 0 20 20" width="100%" height="100%">
								<polygon fill="rgb(210,210,210)" points="20,20 0,0 20,0 "></polygon>
								<polygon fill="#FFFFFF" points="17.844,4.824 15.113,4.824 15.113,2.094 13.355,2.094 13.355,4.824 10.625,4.824 10.625,6.582 13.355,6.582 13.355,9.312 15.113,9.312 15.113,6.582 17.844,6.582 "></polygon>

								<polygon fill="rgb(210,210,210)" points="20,20 0,0 20,0 "></polygon>
								<polygon fill="#FFFFFF" points="17.844,4.824 15.113,4.824 15.113,2.094 13.355,2.094 13.355,4.824 10.625,4.824 10.625,6.582 13.355,6.582 13.355,9.312 15.113,9.312 15.113,6.582 17.844,6.582 "></polygon>
						</svg>
					</div>
			</div>
		</div>
		<div class="serive-link">
			<div class="serive-img">
				<img src="static/image/bright-img/service.jpg"/>
				<div class="serive-icon">
					<div class="wrapper">
						<div class="inner-icon">
							<talk-svg></talk-svg>
						</div>
						<span class="serive">{{$t('serivelink[3]')}}</span>
					</div>
					<!-- <div class="wrapper">
						<div class="inner-icon">
							<alfa-svg></alfa-svg>
						</div>
						<span class="serive">{{$t('serivelink[4]')}}</span>
					</div> -->
				</div>
			</div>
			<div class="service-w">
				<span class="wehope">{{wehope}}</span>
			</div>
		</div>
		<div class="friend-link">
			<span class="all-product">{{$t('serivelink[5]')}}</span>
			<div class="friend-link-wrapper">
				<a class="friend-logo" v-for="(item, index) in logoLink" :href="index" target="view_window">
					<img :src="'static/image/bright-img/friend-logo/' + item + '.jpg'"/>
				</a>
			</div>
		</div>
		<div class="load-img" v-show="lodeimg">
			<load-img class="load-img-content" ></load-img>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
import circleImg from 'components/circle-img/circle-img'
import circleImgEn from 'components/circle-img/circle-imgEn'
// import largeSearch from 'common/large-search/large-search'
import workSvg from 'common/only-svg/work-svg'
import downloadSvg from 'common/only-svg/download-svg'
import talkSvg from 'common/only-svg/talk-svg'
import alfaSvg from 'common/only-svg/alfa-svg'
import loadImg from 'common/load-img/load-img'
// import smallSearch from 'common/small-search/small-search'

export default {
	data() {
		return {
			x: this.$t("charpter-one.cp-three-top"),
			lodeimg: true,
			imgShow: true,
			logoLink: {
				'https://www.budenheim.com/en/': 1,
				'http://www.struktol.com/': 2,
				'https://www.byk.com/cn': 3,
				'http://www.tolsa.com/': 4,
				'http://www.lucobit-china.com/': 5,
				'https://www.frxpolymers.com/': 6,
				'https://www.oka-tec.com/': 7,
				'http://www.bfchemicals.com': 8,
				'http://www.Hycat.com': 9,
				'http://www.bostik.com.cn/cn/china/': 10,
				'http://www.polyram-group.com': 11,
				'https://www.roquette.com/': 12,
				'https://www.velox.com/home/': 13,
				'http://www.apvcoatings.com/': 14,
				'https://www.reagens-group.com/': 15
			}
			}
		},
	created() {
	},
	methods: {
		changeToEn() {
			this.imgShow = !this.imgShow
		},
		getEle(index) {
			let svgEle = document.getElementsByClassName(index)
				for(let i = 0; i < svgEle.length; i++) {
					let sty = svgEle[i].style
					sty.display = 'block'
					sty.width = "100%"
					sty.position = "absolute"
					sty.bottom = 0
					sty.index = -1
					sty.opacity = 0.8
			}
		},
		removeEle(index) {
			let svgEle = document.getElementsByClassName(index)
				for(let i = 0; i < svgEle.length; i++) {
					svgEle[i].style.display = 'none'
			}
		},
		changeImg(index) {
			this.getEle(index)
		},
		returnImg(index) {
			this.removeEle(index)
		},
		jump(index) {
			let num = 'prouductCenter/page' + index
			let com = parseInt(index) +1
			let routid = 'arch' + com
			console.log(com)
			this.$router.push({path: num})
			localStorage.setItem('id', routid)
		},
		inlineChat() {
			this.$router.push('inlineChat')
		}
	},
	computed: {
		productText() {
			return this.$t('productText')
		},
		wehope() {
			return this.$t("wehope")
		}
	},
	mounted() {
		this.lodeimg = false
	},
	components:{
		circleImg,
		circleImgEn,
		// largeSearch,
		workSvg,
		downloadSvg,
		talkSvg,
		alfaSvg,
		loadImg,
		// smallSearch
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.bright-main
		position: relative
		color: $color-theme
		font-size: 0
		.small-search
			position: absolute
			background: $color-theme
			height: 35px
			@media screen and (max-width:550px)
				display: none
			// margin-top: -22px
			width: 100%
		.content
			width: 85%
			margin: 70px auto
			@media screen and (max-width:550px)
				margin: 50px auto
		.content>span
			display: block
			text-align: center
		.title
			font-size: $font-web-large
		.entitle
			color: $color-text-g
			line-height: 22px
			font-size: $font-web-medium-s
		.chapter1
			display: flex
			flex-wrap: wrap
			justify-content: center
			margin: 50px 0
			@media screen and (max-width:550px)
				margin: 20px 0
			.mix-content
				flex: 1
				min-width: 25%
				max-width: 25%
				margin: 10px 25px
				text-align: justify
				@media screen and (max-width:700px)
					margin: 10px 15px
				@media screen and (max-width:550px)
					min-width: 70%
					max-width: 70%
			.mix-content>span
				display: block
			.min-title
				font-size: $font-web-small
				text-align: center
				position: relative
				width: 90%
				margin: -10px auto 10px
				padding: 5px
				color: $color-text
				background: $color-theme
				@media screen and (max-width:700px)
					font-size: $font-web-small-s
			.inner-img
				width: 100%
			.min-inner
				margin: 15px 0
				font-size: $font-web-small-s
				line-height: 18px
				color: $color-text-g
		.inner-img
			width: 100%
			position: relative
			.car-img
				width: 100%
			.search-box
				position: absolute
				top: 15%
				right: 80px
				width: 28%
				@media screen and (max-width:700px)
					display: none
		.product-link
			position: relative
			width: 85%
			display: flex
			flex-wrap: wrap
			justify-content: space-center
			margin: 100px auto 60px
			@media screen and (max-width:750px)
				width: 75%
			.all-product
				position: absolute
				top: -50px
				left: calc(50% - 75px)
				width: 150px
				display: block
				margin: 0 auto
				text-align: center
				line-height: 30px
				height: 30px
				font-size: $font-size-medium
				background: $color-theme
				color: $color-text
				cursor: pointer
				&:hover
					background: $color-text
					color: $color-theme
					border: 1px solid $color-theme
			.click-link
				position: relative
				flex: 1
				overflow: hidden
				min-width: 25%
				max-width: 25%
				height: 70px
				border: 1px solid $color-text-m
				border-radius: 3px
				margin: 40px 25px
				cursor: pointer
				&:hover .click-img
					display: none
				&:hover span
					padding-left: 0px
					font-size: $font-web-medium-s
				@media screen and (max-width:750px)
					min-width: 35%
					max-width: 35%
					margin: 20px 15px
				img:nth-child(1)
					display: none
				.click-img
					position: absolute
					top: 3px
					left: 3px
					width: 62px
					border-radius: 3px
					@media screen and (max-width:550px)
						display: none
				span
					position: relative
					z-index: 200
					font-size: $font-web-small
					display: block
					text-align: center
					padding-left: 50px
					line-height:70px
					&:hover
						color: $color-text
					@media screen and (max-width:550px)
						padding: 0
						font-size: $font-web-small-ss
				.click-svg
					position: absolute
					top: 0
					right: 0
					width: 40px
					padding: 3px
			.click-link:nth-last-child(1)
				width: 20px
				&:hover span
					color: $color-theme
	.serive-link
		position: relative
		.all-product
			width: 150px
			display: block
			margin: 0 auto
			text-align: center
			line-height: 30px
			height: 30px
			font-size: $font-size-medium
			background: $color-theme
			color: $color-text
			cursor: pointer
			&:hover
				background: $color-text
				color: $color-theme
				border: 1px solid $color-theme
		.serive-img
			position: relative
			margin: 50px 0
			width: 100%
			overflow: hidden
			img
				width: 100%
				@media screen and (max-width:550px)
					width: 200%
			.serive-icon
				position: absolute
				width: 35%
				right: 40px
				top: 30%
				display: flex
				justify-content: flex-start
				@media screen and (max-width:850px)
					top: 10%
				@media screen and (max-width:550px)
					width: 80%
					right: 10%
					top: 20%
				.wrapper
					flex: 1
					display: flex
					flex-direction: column
					align-items: center
					.inner-icon
						display:block
						cursor: pointer
						flex: 1
						.only-svg
							width: 45px
							display: inline
				.serive
					display: block
					color: $color-text
					font-size: $font-web-small
					margin-top: 5px
					text-align: center
					line-height: 15px
					flex: 1
					@media screen and (max-width:550px)
						color: $color-theme
		.service-w
			position: absolute
			bottom: -30px
			right: 30px
			width: 35%
			background: $color-theme
			@media screen and (max-width:550px)
				width: 80%
				margin: 0 auto
				right: 10%
			.wehope
				display: block
				color: $color-text
				font-size: $font-web-small
				padding: 15px
				@media screen and (max-width:850px)
					font-size: 0.6rem
	.friend-link
		position: relative
		margin: 100px 0
		@media screen and (max-width:550px)
			margin-bottom: 0
		.all-product
			width: 150px
			display: block
			margin: 0 auto
			text-align: center
			line-height: 30px
			height: 30px
			font-size: $font-size-medium
			background: $color-theme
			color: $color-text
			cursor: pointer
			&:hover
				background: $color-text
				color: $color-theme
				border: 1px solid $color-theme
		.friend-link-wrapper
			width: 80%
			margin: 50px auto
			display: flex
			flex-wrap: wrap
			justify-content: space-between
			.friend-logo
				felx: 1
				width: 20%
				padding: 20px
				cursor: pointer
				@media screen and (max-width:850px)
					width: 30%
				img
					width: 80%
					padding-left: 22%
					@media screen and (max-width:550px)
						width: 100%
						padding: 0
	.load-img
		position: absolute
		top: 0
		left: 0
		right: 0
		height: 100vh
		background: $color-text
		z-index: 200
		.load-img-content
			position: absolute
			left: calc(50% - 30px)
			top: 45%
</style>



// WEBPACK FOOTER //
// src/components/bright-main/bright-main.vue